<template>
  <p :style="`color: ${calculatedColor}`" class="p">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'SxP',
  props: {
    color: {
      type: String,
      required: false,
    },
  },
  data() {
    const getColor = () => {
      const isCurrentColor = this.color === 'currentcolor';
      const isGray = this.color === 'gray';

      if (isCurrentColor) return 'currentcolor';
      if (isGray) return 'var(--gray-800)';

      return 'var(--gray-900)';
    };

    return {
      calculatedColor: getColor(),
    };
  },
};
</script>

<style scoped>
.p {
  display: inline;
  margin-top: 0;
  margin-bottom: 0;

  color: var(--gray-800);

  font-size: 16px;
  font-family: var(--font-family-sans);
  font-weight: 400;
  line-height: 24px;
  text-align: left !important; /* NOTE @chris Global leak. */
}

.p b {
  font-weight: 500;
}
</style>
